<template>
  <div class="list-wrapper">
    <div class="search">
      <div class="search-ipt">
        <div class="search-input">
          <input type="text" placeholder="搜索付款方名称" v-model="searchParams.purchaserName">
        </div>
        <div class="search-icon" @click="onRefresh">
          搜索
        </div>
      </div>
      <div class="filter-option">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="searchParams.invoiceStatus"
            :options="statusOptions"
            @change="changeStatus"
          />
          <van-dropdown-item
            v-model="searchParams.invoiceType"
            :options="invoiceTypeOptions"
            @change="changeType"
          />
          <van-dropdown-item
            v-model="searchOptions.applyDate"
            :options="applyDateOptions"
            @change="changeApplyDate"
          />
        </van-dropdown-menu>
        <p class="filter-btn" @click="openAllCard" v-if="!this.cardOpened">批量发邮箱</p>
      </div>
    </div>

    <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell
            v-for="(invoice, index) in invoiceList"
            :key="index" :ref="'swipecell'+invoice.id"
            :name="invoice.id"
            :disabled="true"
            :before-close="beforeClose"
            :class="[!cardOpened ? 'swiper-cell-custom-wrp': ''].join(' ')"
          >
            <slot slot="left" name="left">
              <div class="select-wrp" v-if="disabledInvoice(invoice.invoiceType)"><i class="iconfont select-font-disabled">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="!invoice.select"><i class="iconfont select-font" v-tap="{methods: selectInvoice, params:{invoice}}">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="invoice.select"><i class="iconfont select-font-active" v-tap="{methods: cancelInvoice, params:{invoice}}">&#xe69d;</i></div>
            </slot>
            <InvoiceCard
              :invoice="invoice"
              :withGetType="false"
              :btnList="getBtnList(invoice)"
              :disabledBtnList="hasLayoutFile(invoice) ? [] : ['downloadLayout']"
              :showFullPurchaserName="true"
              :showInvoiceNo="true"
              cardClickType="detail"
              @download-layout="openLayoutDownload"
            />
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>

    <div :class="['select-footer', showEmailInput? 'email-footer' : ''].join(' ')" v-if="cardOpened">
      <div class="wrp" v-if="!showEmailInput">
        <div class="select-wrp" v-if="selectCount === 0 || selectCount !== getElectricCount(invoiceList)"><i class="iconfont select-font" v-tap="{methods: selectAllInvoice, params:{}}">&#xe69c;</i></div>
        <div class="select-wrp" v-else ><i class="iconfont select-font-active" v-tap="{methods: cancelAllInvoice, params:{}}">&#xe69d;</i></div>
        <div class="content">全选</div>
        <div class="content">已选择<span>{{selectCount}}张</span>发票</div>
      </div>
      <div class="email-input" v-if="showEmailInput">
        <InputField
          type="text"
          :value="emailParams.mailAddress"
          placeholder="请输入邮箱"
          @oninputchange="($event) => onInputChange({e: $event, field:'mailAddress'})"
        />
        <div class="content">已选择<span>{{selectCount}}张</span>发票</div>
      </div>
      <div class="btn-wrp">
        <van-button
          class="btn"
          round
          @click="openAllCard"
        >
          取消
        </van-button>
        <van-button
          v-if="!showEmailInput"
          class="btn"
          round
          @click="changeEmailVisible"
        >
          批量发邮箱
        </van-button>
        <van-button
          v-if="showEmailInput"
          class="btn"
          round
          @click="sendEmail"
        >
          发送
        </van-button>
      </div>
    </div>

    <van-action-sheet
      v-model="layoutDownloadVisible"
      title="下载版式文件"
      cancel-text="取消"
      :actions="layoutFileActions"
      @select="downloadLayoutFile"
    />
  </div>
</template>

<script>
import { invoiceRequest } from '@services'
import InvoiceCard from '@components/InvoiceCard'
import InputField from '@components/InputField'
import { download, isEmail, isElectricTicket } from '@utils/basicUtil'
import { getLayoutFileActions, hasLayoutFile, isCrossOriginUrl } from './layoutFiles'
import {
  ActionSheet,
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  SwipeCell,
  Button,
  Notify
} from 'vant'
import moment from 'moment'
import Observer from '@utils/observer'
export default {
  components: {
    [ActionSheet.name]: ActionSheet,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [SwipeCell.name]: SwipeCell,
    [Notify.name]: Notify,
    [Button.name]: Button,
    InvoiceCard,
    InputField
  },
  props: {},
  data () {
    return {
      statusOptions: [
        { text: '全部状态', value: undefined },
        { text: '正常', value: '10' },
        { text: '红冲', value: '20' },
        { text: '作废', value: '30' }
      ],
      invoiceTypeOptions: [
        { text: '全部类型', value: undefined },
        { text: '专票', value: '1' },
        { text: '普票', value: '2' },
        { text: '电子普票', value: '3' },
        { text: '电子专票', value: '4' },
        { text: '机动车', value: '5' },
        { text: '数电普票', value: '7' },
        { text: '数电专票', value: '8' }
      ],
      applyDateOptions: [
        { text: '申请日期', value: undefined }
      ],
      searchParams: {
        size: 25,
        current: 1,
        purchaserName: '',
        invoiceStatus: undefined
      },
      searchOptions: {
        applyDate: undefined
      },
      invoiceList: [],
      refreshing: false,
      loading: false,
      finished: false,
      cardOpened: false,
      selectCount: 0,
      showEmailInput: false,
      emailParams: {
        mailAddress: '',
        source: 2,
        invoiceIds: []
      },
      layoutDownloadVisible: false,
      selectedInvoice: null
    }
  },
  computed: {
    layoutFileActions () {
      if (!this.selectedInvoice) {
        return []
      }
      return getLayoutFileActions(this.selectedInvoice)
    }
  },
  watch: {},
  created () {},
  mounted () {
    let { searchParams, searchOptions } = this.$store.state.invoice.invoiceHomeInvoiceSearch
    this.searchParams = searchParams
    this.searchOptions = searchOptions
    this.initApplyDateOptions()
    this.getList()
    Observer.setFunction({ type: 'changeCompany', fn: this.companyChangeRefresh })
  },
  activated () {},
  updated () {},
  methods: {
    disabledInvoice (invoiceType) {
      // 只有电票才能发送邮箱
      return !isElectricTicket(invoiceType)
    },
    companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/invoice/invoice-home?active=1') {
        this.onRefresh()
      }
    },
    getList () {
      this.getApplyList()
    },
    initApplyDateOptions () {
      let applyDateOptions = [
        { text: '开票日期', value: undefined }
      ]
      var data = new Date()
      // var year = data.getFullYear()
      data.setMonth(data.getMonth() + 1, 1) // 获取到当前月份,设置月份
      for (var i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        var m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let value = data.getFullYear() + '-' + (m)
        applyDateOptions.push({ text: value, value: value })
      }
      this.applyDateOptions = applyDateOptions
    },
    async getApplyList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const postData = {
        // logisticsStatus: this.active === 'all' ? undefined : Number(this.active),
        ...this.searchParams
      }
      const data = await invoiceRequest.statistics.getStatsMobildList(postData)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }
      this.loading = false
    },
    async sendEmail () {
      if (!this.testEmail()) {
        return
      }
      let ids = []
      this.invoiceList.forEach(v => {
        if (v.select) {
          ids.push(v.id)
        }
      })
      let params = {
        mailAddress: this.emailParams.mailAddress,
        source: this.emailParams.source,
        invoiceIds: ids
      }
      const data = await invoiceRequest.apply.sendEmail(params)
      if (data.success) {
        Notify({ type: 'success', message: '提交成功' })
        this.onRefresh()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    testEmail () {
      if (!this.emailParams.mailAddress) {
        Notify({ type: 'danger', message: '请填写邮箱' })
        return false
      }
      if (!isEmail(this.emailParams.mailAddress)) {
        Notify({ type: 'danger', message: '邮箱格式有误' })
        return false
      }
      return true
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.cardOpened = false
      this.selectCount = 0
      this.invoiceList = []
      this.getApplyList()
    },
    onLoad () {
      this.searchParams.current++
      this.getApplyList()
    },
    changeStatus (value) {
      this.searchParams.invoiceStatus = value
      this.onRefresh()
    },
    changeType (value) {
      this.searchParams.changeType = value
      this.onRefresh()
    },
    onInputChange ({ e, field }) {
      if (field === 'mailAddress') {
        this.emailParams.mailAddress = e
      }
    },
    changeEmailVisible () {
      let ids = []
      this.invoiceList.forEach(v => {
        if (v.select) {
          ids.push(v.id)
        }
      })
      if (!ids.length) {
        Notify({ type: 'danger', message: '请选择要发送的电票' })
        return
      }
      this.showEmailInput = true
      this.resetEmailParams()
    },
    resetEmailParams () {
      this.emailParams = {
        mailAddress: '',
        source: 2,
        invoiceIds: []
      }
    },
    changeApplyDate (value) {
      // this.searchParams.changeApplyDate = value
      if (value) {
        this.searchParams.startTime = moment(value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.endTime = moment(value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      }
      this.onRefresh()
    },
    selectInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = true
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    cancelInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = false
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    selectAllInvoice (data) {
      this.invoiceList.forEach(v => {
        if (this.checkElectricInvoice(v)) {
          v.select = true
        }
      })
      this.selectCount = this.getElectricCount(this.invoiceList)
    },
    checkElectricInvoice (invoice) {
      if (invoice.invoiceType === 3) {
        return true
      }
      return false
    },
    getElectricCount (list) {
      return list.filter(v => this.checkElectricInvoice(v)).length
    },
    cancelAllInvoice (data) {
      this.invoiceList.forEach(v => {
        v.select = false
      })
      this.selectCount = 0
    },
    openAllCard () {
      if (this.cardOpened) {
        this.cardOpened = false
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].close('left')
          }
        })
      } else {
        this.cardOpened = true
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].open('left')
          }
        })
      }
      this.showEmailInput = false
    },
    beforeClose ({ position, instance }) {
      switch (position) {
        case 'left':
          break
      }
    },
    hasLayoutFile (invoice) {
      return hasLayoutFile(invoice)
    },
    openLayoutDownload (invoice) {
      this.selectedInvoice = invoice
      this.layoutDownloadVisible = true
    },
    downloadLayoutFile (action) {
      const url = this.selectedInvoice && this.selectedInvoice[action.field]
      if (!url) {
        return
      }
      this.layoutDownloadVisible = false
      Notify({ type: 'success', message: `正在下载${action.name}版式文件...` })
      const crossOrigin = isCrossOriginUrl(url, window.location.origin)
      download({
        url,
        target: crossOrigin ? '_blank' : undefined,
        rel: crossOrigin ? 'noopener noreferrer' : undefined
      })
    },
    getBtnList (invoice) {
      let btnList
      if (this.isIssuedInvoice(invoice)) { // 税局代开
        btnList = ['preview']
      } else if (invoice.invoiceStatus === 10 || invoice.invoiceStatus === 15 || invoice.invoiceStatus === 25) { // 正常   15红冲中 25作废中 属于 正常状态
        if (invoice.amount < 0) {
          btnList = ['preview'] // 销项负数
        }
      } else if (invoice.invoiceStatus === 20) { // 红冲
        btnList = ['preview']
      } else if (invoice.invoiceStatus === 30) { // 作废
        btnList = ['preview']
      }
      btnList = btnList || ['preview', 'more']
      btnList.splice(1, 0, 'downloadLayout')
      return btnList
    },
    isIssuedInvoice (invoice) { // 判断是否是税局代开的发票，手机端查的是匹配过的发票，匹配过的就是1
      if (invoice.matchFlag === 1) {
        return true
      }
      return false
    }
  },
  beforeDestroy () {
    let params = {
      searchParams: {
        ...this.searchParams,
        current: 1
      },
      searchOptions: this.searchOptions
    }
    this.$store.commit('invoice/saveInvoiceHomeInvoiceSearch', params)
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
